import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import Loader from "../../../components/partials/components/loader";
import { getApiCall } from "../../../service/httpCall";
import { toast } from "react-toastify";
import { USER_ROLES } from "../../../utilities/constant";

import { API_BACKEND_LOGS } from "../../../service/url";
import { Button } from "react-bootstrap";
import { Storage } from "../../../utilities/setting";

const levelColors = {
  error: "#ef4444",
  warn: "#f59e0b",
  info: "#3b82f6",
};

const timeOptions = [
  { label: "Last 5 mins", value: "5" },
  { label: "Last 15 mins", value: "15" },
  { label: "Last 30 mins", value: "30" },
  { label: "Last 45 mins", value: "45" },
  { label: "Whole Day", value: "day" },
  { label: "Custom", value: "custom" },
];

const LogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);
  const [filters, setFilters] = useState({
    type: "combined",
    date: getTodayDate(),
    level: "",
    search: "",
    timeRange: "5",
    fromTime: "",
    toTime: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(filters);

  const logTypes = [
    "combined",
    "users",
    "outbound_campaigns",
    "numbers",
    "agents",
    "cdr_service",
    "billing_service",
    "report_download_service",
  ];

  const levels = ["info", "error", "warn"];

  function getTodayDate() {
    return new Date().toISOString().split("T")[0];
  }

  function getYesterdayDate() {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return d.toISOString().split("T")[0];
  }

  useEffect(() => {
    async function checkUserRole() {
      const rawUser = Storage.getItem("user");
      if (!rawUser) return;

      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON", e);
        return;
      }

      setLoggedInUserRole(user.role);
    }

    checkUserRole();
  }, []);

  useEffect(() => {
    if (!loggedInUserRole) return;
    if (loggedInUserRole !== USER_ROLES.SUPERADMIN) return;

    fetchLogs();
  }, [loggedInUserRole, appliedFilters]);

  const fetchLogs = () => {
    setLoading(true);

    const query = `?type=${appliedFilters.type}&date=${appliedFilters.date}&level=${appliedFilters.level}&search=${appliedFilters.search}&timeRange=${appliedFilters.timeRange}&fromTime=${appliedFilters.fromTime || ""}&toTime=${appliedFilters.toTime || ""}`;

    getApiCall(`${API_BACKEND_LOGS}${query}`)
      .then((res) => {
        const formatted = res?.map((line, index) => ({
          id: index + 1,
          log: line,
        }));
        setLogs(formatted);
      })
      .catch((err) => toast.error(err))
      .finally(() => setLoading(false));
  };

  if (loggedInUserRole && loggedInUserRole !== USER_ROLES.SUPERADMIN) {
    return <div style={{ padding: 20 }}>Access Denied</div>;
  }

  if (loading) return <Loader />;

  return (
    <div className="dash-section-card">
      <div className="dash-section-header">
        <h3>Logs Viewer</h3>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          padding: "12px 14px",
          borderRadius: "12px",
          border: "1px solid #e5e7eb2d",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <Dropdown
            value={filters.type}
            options={logTypes}
            onChange={(e) => setFilters({ ...filters, type: e.value })}
            placeholder="Type"
            style={{ minWidth: 140 }}
          />

          <Dropdown
            value={filters.level}
            options={levels}
            onChange={(e) => setFilters({ ...filters, level: e.value })}
            placeholder="Type"
            showClear
            style={{ minWidth: 120 }}
            itemTemplate={(option) => (
              <span style={{ color: levelColors[option], fontWeight: 500 }}>
                {option.toUpperCase()}
              </span>
            )}
          />

          <div style={{ flex: 1, minWidth: 200 }}>
            <InputText
              placeholder="Search logs..."
              value={filters.search}
              onChange={(e) =>
                setFilters({ ...filters, search: e.target.value })
              }
              style={{ width: "100%" }}
            />
          </div>

          <Button
            variant="primary"
            disabled={loading}
            onClick={() => setAppliedFilters({ ...filters })}
            style={{ borderRadius: "8px", padding: "6px 14px" }}
          >
            Apply
          </Button>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "4px 10px",
              borderRadius: "999px",
            }}
          >
            <span style={{ fontSize: 12, opacity: 0.7 }}>Date:</span>
            <Dropdown
              value={filters.date}
              options={[getTodayDate(), getYesterdayDate()]}
              onChange={(e) => setFilters({ ...filters, date: e.value })}
              style={{ border: "none" }}
            />
          </div>

          <Dropdown
            value={filters.timeRange}
            options={timeOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(e) =>
              setFilters({
                ...filters,
                timeRange: e.value,
                fromTime: "",
                toTime: "",
              })
            }
            placeholder="Time"
            style={{ minWidth: 160 }}
          />
          {filters.timeRange === "custom" && (
            <div style={{ display: "flex", gap: "6px" }}>
              <input
                type="time"
                value={filters.fromTime}
                onChange={(e) =>
                  setFilters({ ...filters, fromTime: e.target.value })
                }
                style={{
                  border: "1px solid #e5e7eb38",
                  borderRadius: "6px",
                  padding: "4px 6px",
                }}
              />
              <span style={{ alignSelf: "center", fontSize: 12 }}>→</span>
              <input
                type="time"
                value={filters.toTime}
                onChange={(e) =>
                  setFilters({ ...filters, toTime: e.target.value })
                }
                style={{
                  border: "1px solid #e5e7eb31",
                  borderRadius: "6px",
                  padding: "4px 6px",
                }}
              />
            </div>
          )}

          <Button
            variant="light"
            onClick={() => {
              const defaultFilters = {
                type: "combined",
                date: getTodayDate(),
                level: "",
                search: "",
                timeRange: "5",
                fromTime: "",
                toTime: "",
              };
              setFilters(defaultFilters);
              setAppliedFilters(defaultFilters);
            }}
            style={{
              marginLeft: "auto",
              borderRadius: "8px",
              padding: "6px 12px",
            }}
          >
            Reset
          </Button>
        </div>
      </div>
      <div style={{ width: "100%", overflowX: "scroll" }}>
        <DataTable
          value={logs}
          paginator
          rows={100}
          rowsPerPageOptions={[100, 200, 500, 1000, 2000, 5000]}
          globalFilter={globalFilter}
          className="dash-datatable"
          emptyMessage="No logs found"
        >
          <Column
            header="Line No."
            body={(rowData, { rowIndex }) => rowIndex + 1}
            style={{ width: "60px" }}
          />

          <Column
            field="log"
            header="Log"
            body={(rowData) => {
              const line = rowData.log;
              const match = line.match(/(\d{2}:\d{2}:\d{2})/);

              if (!match) {
                return (
                  <span
                    style={{ whiteSpace: "pre-wrap", fontFamily: "monospace" }}
                  >
                    {line}
                  </span>
                );
              }

              const time = match[0];
              const parts = line.split(time);

              return (
                <span
                  style={{ whiteSpace: "pre-wrap", fontFamily: "monospace" }}
                >
                  {parts[0]}

                  <span
                    style={{
                      fontWeight: "bold",
                      fontStyle: "italic",
                      textDecoration: "underline",
                      fontSize: "16px",
                      color: "rgb(0, 132, 219)",
                    }}
                  >
                    --{time}--
                  </span>

                  {parts[1]}
                </span>
              );
            }}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default LogsPage;
